import React from "react";

export const BasicButton = ({
  styles = "",
  importance,
  size = null,
  dataCy = null,
  dataTestId = null,
  ...props
}) => {
  const importanceStyles = {
    primary:
      "bg-indigo-500 border-indigo-500 hover:bg-indigo-700 text-white transition-all focus:outline-none disabled:bg-gray-400 disabled:border-gray-400 disabled:dark:border-gray-600 disabled:dark:bg-gray-600",
    secondary:
      "border-indigo-500 disabled:bg-gray-400 disabled:border-gray-400 disabled:text-white disabled:dark:text-white text-indigo-500 hover:text-white hover:bg-indigo-500",
    danger:
      "bg-red-500 border-red-500 hover:bg-red-700 text-white transition-all focus:outline-none disabled:bg-gray-400 disabled:border-gray-400 disabled:dark:border-gray-600 disabled:dark:bg-gray-600",
  };

  const buttonClass = `
    ${importanceStyles[importance || "primary"]}
    ${
      size === "lg"
        ? "px-6 py-2 text-lg shadow-md"
        : "px-4 py-2 text-sm shadow-sm"
    }
    flex-grow-0 flex flex-row items-center self-center border rounded-full font-medium outline-none transition-all
    ${styles}
  `;

  const button = (
    <button
      data-cy={dataCy}
      data-testid={dataTestId}
      className={buttonClass}
      {...props}
    >
      {props.children}
    </button>
  );
  return button;
};
